
// const url = "https://trade5gen.com/api/controller/api-controller/actionLogin";
// const url = "http://192.168.1.9/ecom/webb/api/controller/api-controller";
// const url = "https://ansysoft.com/projects/ecom/webb/api/controller/api-controller";
const url = "https://ansysoft.com/webb-api/controller/api-controller";

export function userLogin(loginData) {
    return new Promise(async (resolve, reject) => {
        try {
            const config = {
                "Content-type": "application/json",
            }

            // console.log(loginData); return;
            const response = await fetch(`${url}/actionLogin`, {
                method: "POST",
                headers: config,
                body: loginData,
            });

            if (response.status === 200) {
                const data = await response.json();
                // alert(JSON.stringify(data));
                // alert(JSON.stringify(data));
                // console.log(data);
                // window.location.replace(`https://trade5gen.com/api/user/user.php?customer_id=${data.lastCallData.PRO_U_SESS}`);
                // window.location.replace(`http://192.168.1.9/ecom/webb/api/user/user.php?customer_id=${data.lastCallData.PRO_U_SESS}`);
                // window.location.replace(`https://ansysoft.com/projects/ecom/webb/api/user/user.php?customer_id=${data.lastCallData.PRO_U_SESS}`);
                window.location.replace(`https://ansysoft.com/webb-api/user/user.php?customer_id=${data.lastCallData.PRO_U_SESS}`);
                resolve(data);
            }
            else {
                const error = await response.text();
                alert("Invalid Credential!");
                return 0;
                // reject(error);
            }
        } catch (error) {
            reject(error);
        }
    });
}

export function fetchNFTs() {
    return new Promise(async (resolve, reject) => {
        try {
            // console.log(loginData); return;
            // const response = await fetch(`https://ansysoft.com/projects/ecom/webb/api/controller/api-controller/nft-card`, {
            const response = await fetch(`https://ansysoft.com/webb-api/controller/api-controller/nft-card`, {
            // const response = await fetch(`http://192.168.1.9/ecom/webb/api/controller/api-controller/nft-card`, {
                method: "GET"
            });

            if (response.status === 200) {
                const data = await response.json();
                resolve(data);
            }
            else {
                const error = await response.text();
                alert("Invalid Credential!");
                return 0;
                // reject(error);
            }
        }
        catch (error) {
            reject(error);
        }
    });
}